<template>
    <div class="mb-2 col-md-6" v-if="isVisible">
        <el-select
            :multiple="multiple"
            :clearable="clearable"
            :value="pending"
            @change="onChange"
            class="w-100"
            :placeholder="placeholder"
            :filterable="filterable"
        >
            <el-option
                v-for="option in options"
                :key="option[optionKey]"
                :label="option[optionLabel]"
                :value="option[optionValue]"
                :disabled="option[optionDisabled]"
            >
            </el-option>
        </el-select>
    </div>
</template>

<script>
    import BaseSelectFilter from "./base-select-filter";

    export default {
        extends: BaseSelectFilter,

        computed: {
            /**
             * @return {Boolean}
             */
            options() {
                return _.get(this.data, 'options', []);
            },
        },
    }
</script>
